import React from 'react'
import clsx from 'clsx'


import './AppListItemStyles.scss'
import './AppListItemProps'
import {AppListItemProps} from "./AppListItemProps";

export const AppListItem = (props: AppListItemProps) => {

    const {html, children, bold = false, italic = false, className, ...rest} = props

    if (html) {
        return (
            <li className={clsx("app-list-item", {"font-bold": bold, "italic": italic,}, className)}
                dangerouslySetInnerHTML={{__html: props.html}}
                {...rest} />
        )
    }

    return (
        <li className={clsx("app-list-item", {"font-bold": bold, "italic": italic,}, className)} {...rest}>
            {children}
        </li>
    );
};
